import {
  Stack,
  Text,
  Heading,
  Columns,
  Column,
  Hidden,
  TextLink,
  IconChevron,
} from 'braid-design-system';

import { LegacyCarousel } from 'src/components/LegacyCarousel/LegacyCarousel';
import ArticleCard from 'src/components/LegacyCarousel/components/ArticleCard/ArticleCard';
import { createDotNetLinkUrl } from 'src/utils';

import { articles } from './data';

const carouselCards = () =>
  articles().map((card, index) => (
    <ArticleCard key={index} htag={`starting-out-item-${index}`} {...card} />
  ));

const StartingOut = () => (
  <Stack space="medium">
    <Heading level="3" component="h2">
      Starting out?
    </Heading>

    <Stack space="small">
      <Columns space="none">
        <Column>
          <Text>Advice and tips on your first steps.</Text>
        </Column>

        <Column width="content">
          <Hidden below="tablet">
            <Text>
              <TextLink
                href={createDotNetLinkUrl(
                  '/business-resources/category/buying-a-business',
                )}
                icon={<IconChevron direction="right" />}
                iconPosition="trailing"
                showVisited={false}
              >
                See all
              </TextLink>
            </Text>
          </Hidden>
        </Column>
      </Columns>

      <LegacyCarousel items={carouselCards()} />
    </Stack>
  </Stack>
);

export default StartingOut;
